const DEFAULT_ERROR = "Something went wrong. Please try again.";

// Read only message-bearing fields. Never stringify an arbitrary response object
// or expose its internal metadata/validation inputs as user-facing error text.
export function formatApiError(detail, fallback = DEFAULT_ERROR) {
  const visited = new WeakSet();
  const message = (value, depth = 0) => {
    if (value == null || depth > 8) return "";
    if (typeof value === "string") return value.trim() === "[object Object]" ? "" : value.trim();
    if (typeof value !== "object" || visited.has(value)) return "";
    visited.add(value);
    if (Array.isArray(value)) return value.map(entry => message(entry, depth + 1)).filter(Boolean).join(" ");
    for (const key of ["message", "msg", "detail", "errors", "error", "reason"]) {
      const text = message(value[key], depth + 1);
      if (text) return text;
    }
    return "";
  };
  return message(detail) || fallback;
}